export default __webpack_public_path__ + "static/media/auth-blob.fe0c0ac2.svg";